import { Outlet } from 'react-router-dom';

import type { PermissionEnum } from '@e-socna/data-layer';

import { useAuthenticationContext } from '../contexts/AuthenticationContext/hooks/useAuthenticationContext.hook';
import { usePermissions } from '../hooks/usePermissions.hook';
import { NotFoundPage } from '../pages/NotFound';

interface Props {
  readonly permission: PermissionEnum;
}

// Pages reached directly by their URL stay unknown to whoever lacks the
// permission they need.
export const RequirePermission = ({ permission }: Readonly<Props>) => {
  const { authenticationData } = useAuthenticationContext();
  const { can } = usePermissions();

  if (!authenticationData) {
    return null;
  }

  return can(permission) ? <Outlet /> : <NotFoundPage />;
};
